// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 894) return "digital-content.52741505a810a8186926.css";
	// return url for filenames based on template
	return "" + chunkId + "." + {"17":"86d843cfeae162989a81","34":"d9a78e3a641942347195","180":"9db0238ad048acbb0e44","373":"24acecc2a42a0d8a3c84","457":"755f4ac2493f2aaf7727","792":"e6ad9aa73da8ef7abeba"}[chunkId] + ".css";
};